import { render, staticRenderFns } from "./VEmployeeTasks.vue?vue&type=template&id=77266401&lang=pug"
import script from "./VEmployeeTasks.vue?vue&type=script&lang=ts"
export * from "./VEmployeeTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports